/**
 * Used for operators that include a list of values (like ONE_OF) and only two possible values are defined
 * It will assume one value or the other is a valid option (like Yes/No or Active/Inactive) and that it makes no sense select both
 */

import {isObject} from 'lodash';
import React from 'react';
import {useCallback} from 'react';
import {useEffect} from 'react';

function BinaryValueSelection(props) {
    const {value, operator, onChange} = props;

    // trigger default value change
    useEffect(() => {
        if (value === undefined) {
            let defaultValue = operator.values[0];
            if (defaultValue.value) defaultValue = defaultValue.value;
            onChange(defaultValue);
        }
    }, []);

    const handleChange = useCallback(e => onChange(JSON.parse(e.target.value)), [onChange]);

    return (
        <select className="form-control" value={JSON.stringify(value)} onChange={handleChange}>
            {operator.values.map((value, i) => {
                if (isObject(value)) {
                    return (
                        <option key={i} value={JSON.stringify(value.value)}>
                            {value.label ?? value.value}
                        </option>
                    );
                } else {
                    return (
                        <option key={i} value={JSON.stringify(value)}>
                            {value}
                        </option>
                    );
                }
            })}
        </select>
    );
}

export default BinaryValueSelection;
